<div class="container mx-auto footer-top message-wrapper w-[90%] md:w-[80%] lg:w-[40%]">
    <div
        class="flex items-center flex-wrap justify-center mb-5 mt-5 mb-5 py-[5px] px-[50px] bg-[#000] shadow-xl rounded-[15px]">
        <p class="text-white">
            This site is for demonstration purposes only, please do not use it for booking.
        </p>
    </div>
</div>